import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader.js'
import MainFooter from '../../../components/MainFooter.js'
import { useCallback, useEffect, useState } from 'react'
import { motion } from "framer-motion";

import './ProjectsOverview.css'
import './MProjectsOverview.css'
import axios from 'axios';
import { URL_STRAPI, API_TOKEN_STRAPI, boxvar3, boxvar1, boxvar2, boxvar2dyndelay, lP } from '../../../core.js'
import ProjectCard from '../../../components/ProjectCard.js';
import CTAButton from '../../../components/CTAButton.js';
import useInitialViewportVisibility from '../../../hooks/useInitialViewportVisibility.js';


export default function ProjectsOverview() {

    var projecttype = new URLSearchParams(window.location.search).get("type");


    const [projectsList, setProjectsList] = useState(null);

    const [showAllProjekte, setShowAllProjekte] = useState(true);
    const [showAllKunden, setShowAllKunden] = useState(true);


    const fetchAllProjects = async () => {
        try {
            const res = await axios.get(`${URL_STRAPI}/api/projects`, {
                params: {
                    'filters[active][$eq]': true,
                    'sort': 'release_date:desc',
                    'populate': '*',
                },
                headers: {
                    Authorization: `Bearer ${API_TOKEN_STRAPI}`,
                },
                timeout: 5000, // Timeout nach 5 Sekunden
            });

            return res.data.data;
        } catch (err) {
            console.error('Fehler beim Laden der Projekte:', err.message || err);
            return [];
            // throw err; 
            // oder: return []; wenn du leere Liste willst statt Exception
        }
    };

    useEffect(() => {
        fetchAllProjects().then((content) => { setProjectsList(content) });

    }, [])

    const projectItems = projectsList ? projectsList.filter((p) => p.type === "projekt" || p.type === "intern") : [];
    const kundenItems = projectsList ? projectsList.filter((p) => p.type === "kunde") : [];
    const getProjectId = useCallback((item) => item.projectid, []);
    const {
        setItemRef: setProjectItemRef,
        isInitiallyVisible: isProjectInitiallyVisible
    } = useInitialViewportVisibility(projectItems, getProjectId, { resetKey: "projects-overview-projects" });
    const {
        setItemRef: setKundenItemRef,
        isInitiallyVisible: isKundenInitiallyVisible
    } = useInitialViewportVisibility(kundenItems, getProjectId, { resetKey: "projects-overview-kunden" });


    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"projects"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Projekte & Produkte</title>
                <meta property="og:title" content="Projekte und Produkte" />
                <meta property="og:description" content="Alle Produkte und Projekte von ToNetwork" />
                <meta name="description" content="Alle Produkte und Projekte von ToNetwork" />
            </Helmet>
            <section className='sec_next' id='sec_next--projectsoverview'>
                <div className='sec_next_cont' id="sec_next--projectsoverview--cont" style={{ wordBreak: "break-word" }}>
                    <br />
                    {(projecttype == "projects" || projecttype == 0 || projecttype == null) && (<>
                        <h2 onClick={() => lP('/projects/?type=projects')} style={{ cursor: 'pointer' }}> Unsere Projekte und Produkte</h2>
                        <br /><br />

                        {(projectsList == [] || projectsList?.length == 0) ? <p>Es wurden keine Projekte gefunden 👀</p> :
                            (projectsList != null) ? (() => {

                                const filtered = projectItems;
                                const visible = showAllProjekte ? filtered : filtered.slice(0, 3);
                                return (
                                    <>
                                        {visible.map(function (projectdata, index) {


                                            return (
                                                // (projectdata.type === "projekt" || projectdata.type === "intern") && (
                                                <motion.div
                                                    key={index}
                                                    ref={setProjectItemRef(projectdata.projectid)}
                                                    variants={boxvar2dyndelay}
                                                    custom={isProjectInitiallyVisible(projectdata.projectid) ? 0.3 * (index + 1) : 0}
                                                    initial="hidden"
                                                    exit="hidden"
                                                    whileInView="visible"
                                                    viewport={{ once: false, margin: "-50px" }}
                                                >

                                                    <ProjectCard projectid={projectdata.projectid} type={projectdata.type} name={projectdata.name} logo_img={projectdata.logo_img} shortdescription={projectdata.shortdescription} />
                                                    <br /><br /><br />
                                                </motion.div>
                                                // )
                                            )
                                        })}

                                        {filtered.length > 3 && (
                                            <div style={{ textAlign: "center", marginTop: "1rem" }}>
                                                <b style={{ cursor: "pointer" }} onClick={() => setShowAllProjekte(!showAllProjekte)}>
                                                    {showAllProjekte ? "▲ Weniger anzeigen" : "▼ Mehr anzeigen"}
                                                </b>
                                            </div>
                                        )}
                                    </>
                                );
                            })() : <div>
                                <p>Projekte werden geladen...</p>

                            </div>}

                        <br /><br /><br /><br />
                        <br /><br /><br /><br />
                    </>)}
                    {(projecttype == "kunden" || projecttype == 0 || projecttype == null) && (<>

                        <h2 onClick={() => lP('/projects/?type=kunden')} style={{ cursor: 'pointer' }}> Unsere Kunden</h2>
                        <br /><br />

                        {(projectsList == [] || projectsList?.length == 0) ? <p>Es wurden keine Kundenprojekte gefunden 👀</p> :
                            (projectsList != null) ? (() => {

                                const filtered = kundenItems;
                                const visible = showAllKunden ? filtered : filtered.slice(0, 3);
                                return (
                                    <>
                                        {visible.map(function (projectdata, index) {

                                            return (
                                                <motion.div
                                                    key={index}
                                                    ref={setKundenItemRef(projectdata.projectid)}
                                                    variants={boxvar2dyndelay}
                                                    custom={isKundenInitiallyVisible(projectdata.projectid) ? 0.4 * (index + 1) : 0}
                                                    initial="hidden"
                                                    exit="hidden"
                                                    whileInView="visible"
                                                    viewport={{ once: false, margin: "-50px" }}
                                                >

                                                    <ProjectCard projectid={projectdata.projectid} type={projectdata.type} name={projectdata.name} logo_img={projectdata.logo_img} shortdescription={projectdata.shortdescription} kunde_logo={projectdata.kunde_logo} kunde_name={projectdata.kunde_name} kunde_url_landing={projectdata.kunde_url_landing} />
                                                    <br /><br /><br />
                                                </motion.div>
                                            )
                                        })}

                                        {filtered.length > 3 && (
                                            <div style={{ textAlign: "center", marginTop: "1rem" }}>
                                                <b style={{ cursor: "pointer" }} onClick={() => setShowAllKunden(!showAllKunden)}>
                                                    {showAllKunden ? "▲ Weniger anzeigen" : "▼ Mehr anzeigen"}
                                                </b>
                                            </div>
                                        )}
                                    </>
                                );
                            })() : <div>
                                <p>Kundenprojekte werden geladen...</p>

                            </div>}
                        <br /><br /><br /><br />
                        <br /><br /><br /><br />
                    </>)}

                    {(projecttype != 0 && projecttype != null) && (
                        <CTAButton className="" showArrow={true} iconLeft={false} title={"Entdecke alle Projekte und Kunden"} href={'/projects/'}></CTAButton>

                    )}

                    <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

                </div >
            </section >

            <MainFooter />
        </div >
    )
}